import { render } from "./EpisodeTV.vue?vue&type=template&id=a84b207a"
import script from "./EpisodeTV.vue?vue&type=script&lang=js"
export * from "./EpisodeTV.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Project Coustomer\\vue film\\film\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__